import axios, { AxiosError } from 'axios';
import { environment } from '../environments/environment';
import { returnBaseUrl } from '../utils/baseURL';
import { useAuth } from 'hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import { IErrorWithSentryId } from 'interfaces/IErrorWithSentryId';

export const useApiClient = () => {
  const auth = useAuth();
  const navigate = useNavigate();

  const portaBackEnd = process.env.REACT_APP_PORTA_BACKEND ?? '8080';
  const isBackEndLocal = process.env.REACT_APP_BACK_END_LOCAL ?? 'false';

  const SITE_ENVIRONMENT = environment.environment;
  let BACK_END_ENVIRONMENT;
  if (isBackEndLocal === 'true') {
    BACK_END_ENVIRONMENT = 'local';
  } else if (SITE_ENVIRONMENT === 'local') {
    BACK_END_ENVIRONMENT = 'des';
  } else {
    BACK_END_ENVIRONMENT = SITE_ENVIRONMENT;
  }
  const SITE_BASE_URL = returnBaseUrl(BACK_END_ENVIRONMENT, portaBackEnd);

  const httpCall = axios.create({
    baseURL: SITE_BASE_URL,
    headers: { 'Content-Type': 'application/json' },
  });

  const userCpfCnpj = sessionStorage.getItem('userCpfCnpj');

  httpCall.interceptors.request.use((config) => {
    const token = auth.getToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      config.headers['X-Cpf-Cnpj-Representado'] = userCpfCnpj;
    } else if (!auth.isAuthenticated) {
      navigate('/logout');
    }
    return config;
  });

  httpCall.interceptors.response.use(
    (response) => {
      return response;
    },
    (error: IErrorWithSentryId) => {
      if (error.response?.status === 401) {
        auth.clearToken();
        navigate('/login');
      }

      return Promise.reject(error);
    }
  );

  return httpCall;
};
